import { GET } from "../utils/constants";
import { fetchData } from "../utils/dataProvider";

export const getRoles = () => fetchData({ url: "/roles", method: GET });
